"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var React = require("react");
var services_1 = require("@falcon/services");
var TrustLogoComponent_1 = require("../widgets/TrustLogoComponent");
var Footer = /** @class */ (function (_super) {
    __extends(Footer, _super);
    function Footer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            showGdprBanner: undefined
        };
        return _this;
    }
    Footer.prototype.render = function () {
        var divider = services_1.resourcesHelper.THEME === "Allianz" ? "" : " | ";
        return (React.createElement("footer", { className: "falcon-footer" },
            React.createElement("div", { className: "falcon-footer-divider" }),
            React.createElement("div", { className: "entrust-section" },
                React.createElement("div", { id: "trust-logo", className: "security-logo position-relative" },
                    React.createElement(TrustLogoComponent_1.TrustLogoComponent, null)),
                React.createElement("div", { className: "entrust-section-wording" },
                    React.createElement("div", { className: "entrust-section-title" }, "We'll keep your details safe"),
                    React.createElement("div", { className: "entrust-section-description" },
                        "Our website is constantly monitored to ",
                        React.createElement("br", null),
                        "check for harmful viruses or malware.")),
                React.createElement("div", { className: "d-flex justify-content-end flex-grow-1" },
                    React.createElement("img", { src: "/Allianz/img/allianz-olympic-logo.svg", alt: "Allianz olympics logo icon" }))),
            React.createElement("div", { className: "falcon-footer-divider-bottom" }),
            React.createElement("hr", { "aria-hidden": "true" }),
            React.createElement("div", { className: "trademark-section" },
                React.createElement("div", { className: "links-container d-mobile-none" },
                    React.createElement("a", { href: "/complaints", id: "complaints", className: "pr-1" }, "Complaints"),
                    divider,
                    React.createElement("a", { href: "https://www.allianz.co.uk/cookie-policy.html", target: "_blank", id: "cookie-policy", className: "pl-1 pr-1" }, "Our cookie policy"),
                    divider,
                    React.createElement("a", { href: "https://www.allianz.co.uk/privacy-notice.html", id: "data-rights", target: "_blank", className: "pl-1" }, "Personal data rights")),
                React.createElement("div", { className: "links-container d-desktop-none" },
                    React.createElement("a", { href: "/complaints", id: "complaints" }, "Complaints"),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("a", { href: "https://www.allianz.co.uk/cookie-policy.html", target: "_blank", id: "cookie-policy" }, "Our cookie policy"),
                    React.createElement("br", null),
                    React.createElement("br", null),
                    React.createElement("a", { href: "https://www.allianz.co.uk/privacy-notice.html", id: "data-rights", target: "_blank" }, "Personal data rights"),
                    React.createElement("br", null),
                    React.createElement("br", null)),
                React.createElement("hr", { "aria-hidden": "true" }),
                React.createElement("div", { className: "trademark-container" },
                    React.createElement("div", null, services_1.resourcesHelper.TRADEMARK)))));
    };
    return Footer;
}(React.Component));
exports.Footer = Footer;
//# sourceMappingURL=Footer.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/navigator/Footer.js
// module id = 352
// module chunks = 0